import { Button } from '../ui/Button';

interface DeleteEventModalProps {
  eventName: string;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog for deleting an event. Kept local to the event detail
 * page so its copy and layout stay unchanged.
 */
export const DeleteEventModal = ({
  eventName,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteEventModalProps) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-gray-50 rounded-lg max-w-md w-full p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        Delete Event
      </h3>
      <p className="text-gray-600 mb-6">
        Are you sure you want to delete "{eventName}"? This action cannot be undone.
      </p>
      <div className="flex gap-3 justify-end">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="bg-red-600 hover:bg-red-700"
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete Event'}
        </Button>
      </div>
    </div>
  </div>
);
